"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = __importDefault(require("../util/error"));
const query_1 = __importDefault(require("./query"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const apollo_1 = require("@app/util/apollo");
const query = (0, graphql_tag_1.default) `mutation ShiftCreateMultiMutation (
  $workspace: ID!,
  $items: [ShiftData!]
) {
  shiftCreateMulti (
    workspace: $workspace
    items: $items
  ) ${query_1.default.SHIFT_BASIC}
}`;
async function requestShiftCreateMulti(variables) {
    const response = await (0, apollo_1.mutate)(query, {
        variables,
    });
    if (!response)
        return error_1.default.noResponse();
    const { errors, data } = response;
    if (errors) {
        return error_1.default.apiError('shift-create-multi', errors);
    }
    return data?.shiftCreateMulti;
}
exports.default = requestShiftCreateMulti;
